<main class="auth-page">
  <section class="auth-shell" aria-labelledby="pending-title">
    <div class="auth-shell__accent"></div>
    <div class="auth-content">
      <a class="auth-brand" routerLink="/login" aria-label="GarageDigital"
        ><img src="assets/images/GD_Logotipo_UI.png" alt="GarageDigital"
      /></a>
      <div class="auth-icon" [class.auth-icon--warning]="deliveryFailed">
        <i
          class="bi"
          [ngClass]="
            deliveryFailed ? 'bi-envelope-exclamation' : 'bi-envelope-check'
          "
        ></i>
      </div>
      <header class="auth-heading">
        <h1 gdClarityUnmask id="pending-title">Revisá tu correo</h1>
        <p>
          Enviamos un enlace de confirmación a <strong>{{ email }}</strong
          >. Usalo para activar tu cuenta.
        </p>
      </header>
      <div *ngIf="deliveryFailed" class="auth-status auth-status--warning">
        <i class="bi bi-exclamation-triangle-fill"></i
        ><span
          >La cuenta fue creada, pero no pudimos enviar el correo. Podés
          intentar reenviarlo ahora.</span
        >
      </div>
      <div class="auth-actions" [class.mt-4]="deliveryFailed">
        <button
          class="auth-button auth-button--outline"
          (click)="resend()"
          [disabled]="sending"
        >
          <gd-inline-spinner *ngIf="sending" size="sm" tone="current" /><i
            *ngIf="!sending"
            class="bi bi-arrow-clockwise"
          ></i
          >{{ sending ? "Reenviando…" : "Reenviar correo" }}
        </button>
      </div>
      <a class="auth-back" routerLink="/login"
        ><i class="bi bi-arrow-left"></i> Ir al inicio de sesión</a
      >
    </div>
  </section>
</main>
